// import 'font-awesome/css/font-awesome.min.css'
import '@mdi/font/css/materialdesignicons.css'
import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
	icons: {
		iconfont: 'mdi', // 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4'
	},
  theme: {
    themes: {
      light: {
        primary: '#26a65b',
        secondary: '#9d9d9d',
        success: '#26a65b',
        info: '#26a65b',
        warning: '#ac4c0f',
        // accent: '#8c9eff',
        // error: '#b71c1c',
      },
      dark: {
        primary: '#0c954a',
        success: '#0c954a',
        info: '#26a65b',
        warning: '#ac4c0f',
      }
    },
  },
});
